import { colors } from '@material-ui/core';

import {
  blue100,
  blueVioletDesat35,
  brownYellow25,
  brownYellow135,
  brownYellow180,
  fluorescentBlueViolet69,
  fluorescentCyan185,
  fluorescentPink119,
  green135,
  greenBlue100,
  greenBlueDesat155,
  orange100,
  orange135,
  pink100,
  pink115,
  red100,
  violet100,
  violet155,
  violetPinkDesat100,
  yellow135,
  yellowGreen100,
  yellowGreen135,
} from '@spotify/confidence-encore-foundation';

type ColorPalette = keyof typeof colors.amber;

const COLOR_MAP = [
  colors.amber,
  colors.blue,
  colors.blueGrey,
  colors.brown,
  colors.cyan,
  colors.deepOrange,
  colors.deepPurple,
  colors.green,
  colors.indigo,
  colors.lightGreen,
  colors.lightBlue,
  colors.lime,
  colors.orange,
  colors.pink,
  colors.purple,
  colors.red,
  colors.teal,
  colors.yellow,
];

export const colorList = Object.values(COLOR_MAP.map(v => v[400]));

const SHADES: ColorPalette[] = [300, 400, 500, 600, 700, 800, 900];

export type PaletteColors =
  | 'blue'
  | 'orange'
  | 'green'
  | 'red'
  | 'pink'
  | 'purple'
  | 'yellow'
  | 'greenBlue';

export const paletteColors: Record<PaletteColors, string> = {
  blue: blue100,
  pink: pink100,
  orange: brownYellow135,
  purple: violet100,
  green: green135,
  red: red100,
  yellow: yellow135,
  greenBlue: greenBlue100,
};

export const stringToColor = (str?: string) => {
  if (!str) return undefined;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colorIndex = Math.abs(hash) % COLOR_MAP.length;
  const palette: Record<ColorPalette, string> = COLOR_MAP[colorIndex];
  const colorShade = SHADES[Math.abs(hash) % SHADES.length];
  const color = palette[colorShade];
  return color;
};

export type ChartColorType =
  | 'pink'
  | 'flourescent'
  | 'yellowGreen'
  | 'brownYellow'
  | 'violet'
  | 'greenBlue'
  | 'blue'
  | 'orange'
  | 'greenBlueDesat';

const chartColors: {
  light: Record<ChartColorType, string>;
  dark: Record<ChartColorType, string>;
} = {
  light: {
    pink: fluorescentPink119,
    flourescent: fluorescentBlueViolet69,
    yellowGreen: yellowGreen100,
    brownYellow: brownYellow25,
    violet: violetPinkDesat100,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange100,
    greenBlueDesat: blueVioletDesat35,
  },
  dark: {
    pink: pink115,
    flourescent: fluorescentCyan185,
    yellowGreen: yellowGreen135,
    brownYellow: brownYellow180,
    violet: violet155,
    greenBlue: greenBlue100,
    blue: blue100,
    orange: orange135,
    greenBlueDesat: greenBlueDesat155,
  },
};

export const getChartColors = (mode: 'light' | 'dark') => {
  return mode === 'light' ? chartColors.light : chartColors.dark;
};

export const defaultChartColors: ChartColorType[] = [
  'pink',
  'flourescent',
  'yellowGreen',
  'violet',
  'blue',
  'greenBlue',
  'orange',
  'greenBlueDesat',
  'brownYellow',
];
